import {gql} from '@apollo/client';

export const MUTATION_SEND_CODE = gql`
mutation sendCode($phone: String!) {
    sendCode(phone: $phone) {
        done
    }
}`

export const MUTATION_CHECK_CODE = gql`
mutation checkCode($phone: String!, $code: String!) {
    checkCode(code: $code, phone: $phone) {
        jwt
    }
}`

export const MUTATION_ACTIVATE = gql`
    mutation activate($code: String!) {
        activate(code: $code) {
            done
        }
    }`

export const MUTATION_UPDATE_USER = gql`
    mutation updateUsersPermissionsUser($data: UsersPermissionsUserInput!, $id: ID!) {
        updateUsersPermissionsUser(id: $id, data: $data) {
            data {
                documentId
            }
        }
    }`

export const MUTATION_PROFILE_BASE = gql`
    mutation profileBase($data: profileBaseInput!) {
        profileBase(data: $data) {
            done
        }
    }`


